<span class="icon" [innerHTML]="icon$ | async"></span>
